import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { PayPalScriptProvider, PayPalButtons } from "@paypal/react-paypal-js";
import { motion } from "framer-motion";
import { FaDollarSign } from "react-icons/fa";

const Donate = () => {
  const { t } = useTranslation();
  const [amount, setAmount] = useState("1");
  const [customAmount, setCustomAmount] = useState("");
  const [loading, setLoading] = useState(false);

  const handleAmountChange = (e) => {
    setAmount(e.target.value);
    if (e.target.value !== "custom") {
      setCustomAmount("");
    }
  };

  return (
    <motion.div
      className="container mx-auto p-4 text-center"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
    >
      <h1 className="text-3xl font-bold primary-text mb-4">{t("donate.title")}</h1>
      <p className="text-lg mb-8">{t("donate.description")}</p>
      <div className="max-w-md mx-auto glass p-6 rounded-lg">
        <h2 className="text-xl font-semibold primary-text mb-4">{t("donate.select_amount")}</h2>
        <div className="flex justify-center space-x-4 mb-4">
          {["1", "5", "10", "custom"].map((value) => (
            <label key={value} className="flex items-center">
              <input
                type="radio"
                value={value}
                checked={amount === value}
                onChange={handleAmountChange}
                className="mr-2"
              />
              {value === "custom" ? t("donate.custom") : `$${value}`}
            </label>
          ))}
        </div>
        {amount === "custom" && (
          <div className="custom-input">
            <input
              type="number"
              id="custom-amount"
              value={customAmount}
              onChange={(e) => setCustomAmount(e.target.value)}
              placeholder=" "
              min="1"
              dir="auto"
            />
            <label htmlFor="custom-amount">{t("donate.custom_placeholder")}</label>
          </div>
        )}
        <PayPalScriptProvider options={{ "client-id": "AalrHPhuw8Ke2Ld-32vdS5BiJOR8vUo99PEroFB5XoA1emUxsd6X57AjbqacPPjqe2rpLUrQncz0U4M0" }}>
          <PayPalButtons
            createOrder={(data, actions) => {
              setLoading(true);
              return actions.order.create({
                purchase_units: [
                  {
                    amount: {
                      value: amount === "custom" ? customAmount || "1.00" : amount,
                    },
                  },
                ],
              });
            }}
            onApprove={(data, actions) => {
              return actions.order.capture().then((details) => {
                setLoading(false);
                alert(`Transaction completed by ${details.payer.name.given_name}`);
              });
            }}
            onError={() => setLoading(false)}
          />
        </PayPalScriptProvider>
        {loading && <div className="loading-spinner mx-auto mt-4"></div>}
      </div>
    </motion.div>
  );
};

export default Donate;